import List from "@/components/list";

const Table = args => {

  const { props } = args;
  const type = props.type || 0;

  let tableConfig = [];

  switch (type) {
    case 1:
      tableConfig = [
        {
          label: "资源名称",
          prop: "name",
          minWidth: "200",
          showOverflowTooltip: true
        },
        {
          label: "状态",
          prop: "onlineStatusName",
          minWidth: "100"
        },
        {
          label: "点击量",
          prop: "playNum",
          minWidth: "100",
          showOverflowTooltip: true
        },
      ]
      break;
    case 3:
      tableConfig = [
        {
          label: "资源名称",
          prop: "name",
          minWidth: "200",
          showOverflowTooltip: true
        },
        {
          label: "状态",
          prop: "onlineStatusName",
          minWidth: "100"
        },
        {
          label: "点击量",
          prop: "playNum",
          minWidth: "100",
          showOverflowTooltip: true
        },
        // {
        //   label: "收藏",
        //   prop: "collectCount",
        //   minWidth: "100",
        //   showOverflowTooltip: true
        // },
      ]
      break;
    case 0:
      tableConfig = [
        {
          label: "资源名称",
          prop: "name",
          minWidth: "200",
          showOverflowTooltip: true
        },
        {
          label: "状态",
          prop: "onlineStatusName",
          minWidth: "100"
        },
        {
          label: "总学习人数",
          prop: "learnTotalCount",
          minWidth: "100",
          showOverflowTooltip: true,
        },
        {
          label: "已完成学习人数",
          prop: "learnCompleteCount",
          minWidth: "100",
          showOverflowTooltip: true
        },
        {
          label: "正学习人数",
          prop: "studyCount",
          minWidth: "100",
          showOverflowTooltip: true
        },
        {
          label: "实际播放量",
          prop: "playNum",
          minWidth: "100",
          showOverflowTooltip: true
        },
        {
          label: "播放量基数",
          prop: "playBaseNum",
          minWidth: "100",
          showOverflowTooltip: true
        },
        // {
        //   label: "收藏",
        //   prop: "collectCount",
        //   minWidth: "100",
        //   showOverflowTooltip: true
        // },
      ]
      break;
  
    default:
      tableConfig = [
        {
          label: "资源名称",
          prop: "name",
          minWidth: "200",
          showOverflowTooltip: true
        },
        {
          label: "状态",
          prop: "onlineStatusName",
          minWidth: "100"
        },
        {
          label: "总学习人数",
          prop: "learnTotalCount",
          minWidth: "100",
          showOverflowTooltip: true,
        },
        {
          label: "已完成学习人数",
          prop: "learnCompleteCount",
          minWidth: "100",
          showOverflowTooltip: true
        },
        {
          label: "正学习人数",
          prop: "studyCount",
          minWidth: "100",
          showOverflowTooltip: true
        },
        {
          label: "点击量",
          prop: "playNum",
          minWidth: "100",
          showOverflowTooltip: true
        },
        // {
        //   label: "收藏",
        //   prop: "collectCount",
        //   minWidth: "100",
        //   showOverflowTooltip: true
        // },
      ]
      break;
  }

  return (
    <List
      {...args}
      maxHeight={330}
      talbeCols={tableConfig}
    />
  );
};

export default Table;
